import { useDispatch, useSelector } from "react-redux";
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  createFilterOptions,
} from "@mui/material";
import "./oportunidadesForm.css";
import NumberFormat from "react-number-format";

import { contactsAddNewCustomer } from "../../redux/actions/contacts";
import { Model } from "../../models/model";
import { Archive, ArchiveRestore } from "lucide-react";

const filter = createFilterOptions();

const OportunidadesForm = ({
  form,
  funnels,
  tiposProspectos,
  listaOrigen,
  saveLead,
  updateForm,
}) => {
  const dispatch = useDispatch();
  const { listCustomers } = useSelector((state) => state.contacts);
  const {
    //local_id_moneda,
    local_simbolo,
    local_separacion_miles,
    local_separacion_decimales,
  } = useSelector((state) => state.general.info);

  const handleContacto = async (newValue) => {
    const values = {
      id: newValue.id ? newValue.id : null,
      nombre: newValue.id ? newValue.nombre_completo : newValue.inputValue,
      clasificacion: "cliente",
      email: newValue.email,
      fono: newValue.telefono,
    };

    let customer = {
      id: values.id,
      nombre: values.nombre,
      email: newValue.email,
      fono: newValue.telefono,
    };

    if (!newValue.id) {
      // Creando nuevo cliente
      const result = await Model.save({
        url: "contacts",
        dataForm: values,
        resultData: true,
      });

      if (result) {
        dispatch(contactsAddNewCustomer(result));
        customer.id = result.id || null;
        customer.nombre = result.nombre || null;
      }
    }

    updateForm({
      id_contacto: customer.id,
      referencia: `Oportunidad de ${customer.nombre}`,
      email: customer.email,
      fono: customer.fono,
    });
  };

  const handleInputChange = ({ target }) => {
    updateForm({
      [target.name]: target.value,
    });
  };

  const handleChangeNumber = (newValues) => {
    const { floatValue } = newValues;
    updateForm({
      total: floatValue,
    });
  };

  const handleArchive = async (newStatus) => {
    const previousStatus = form.estado;

    updateForm({
      estado: newStatus,
    });

    try {
      await saveLead({
        ...form,
        estado: newStatus,
      });
    } catch (error) {
      updateForm({
        estado: previousStatus,
      });
    }
  };

  const handleSave = async () => {
    await saveLead();
  };

  return (
    <div className="mt-[30px] relative">
      <Grid
        container
        spacing="15"
        columnSpacing="10"
        alignItems="center"
        direction="row"
      >
        <div>
          {form.id && (
            <Tooltip title="Archivar oportunidad">
              <div className="flex justify-start items-center mb-2">
                {form.estado === "archivado" ? (
                  <span className="text-orange-500">Archivado</span>
                ) : (
                  <span className="text-green-500">Activo</span>
                )}

                <div className=" text-gray-500 ms-3">
                  {form.estado === "archivado" ? (
                    <button
                      className="flex items-center hover:text-green-500 hover:underline"
                      onClick={() => handleArchive("activo")}
                    >
                      <ArchiveRestore className="w-3" />
                      <label className="ms-1 cursor-pointer">Activar</label>
                    </button>
                  ) : (
                    <button
                      className="flex items-center hover:text-orange-500 hover:underline"
                      onClick={() => handleArchive("archivado")}
                    >
                      <Archive className="w-3" />
                      <label className="ms-1 cursor-pointer">Archivar</label>
                    </button>
                  )}
                </div>
              </div>
            </Tooltip>
          )}

          <h2 className="text-[20px]">
            {form.id ? form.referencia : "Nueva oportunidad"}
          </h2>
          <div className="items-start">
            <select
              className="border-1 border-gray-400 mt-1 mb-1 rounded-2 p-[2px]"
              name="id_etapa"
              disabled={Boolean(form.estado_comercial && form.estado_comercial !== 'abierta')}
              onChange={handleInputChange}
            >
              {funnels.map((it) => {
                if (it.id === form.id_etapa) {
                  return (
                    <option key={it.id} value={it.id} selected>
                      {it.nombre}
                    </option>
                  );
                } else {
                  return (
                    <option key={it.id} value={it.id}>
                      {it.nombre}
                    </option>
                  );
                }
              })}
            </select>
          </div>
        </div>

        <Grid item xs={12}>
          <Autocomplete
            value={
              listCustomers?.find(
                (it) => parseInt(it.id) === parseInt(form.id_contacto),
              ) || null
            }
            onChange={(event, newValue) =>
              handleContacto(newValue || null, "id_contacto")
            }
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
              const { inputValue } = params;

              // Suggest the creation of a new value
              const isExisting = options.some(
                (option) => inputValue === option.nombre,
              );
              if (inputValue !== "" && !isExisting) {
                filtered.push({
                  inputValue,
                  nombre: `Crear  "${inputValue}"`,
                });
              }

              return filtered;
            }}
            id="auto-complete"
            autoComplete
            includeInputInList
            fullWidth
            options={listCustomers}
            getOptionLabel={(option) => {
              // Value selected with enter, right from the input
              if (typeof option === "string") {
                return option;
              }

              // Add "xxx" option created dynamically
              if (option.inputValue) {
                return option.inputValue;
              }

              // Regular option
              return option?.nombre;
            }}
            renderOption={(props, option) => (
              <li {...props}>{option?.nombre || ""}</li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Ingresar contacto"
                variant="standard"
                inputProps={{
                  ...params.inputProps,
                  style: { textTransform: "capitalize" },
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Descripción oportunidad"
            variant="standard"
            name="referencia"
            id="outlined-size-small"
            value={form?.referencia || ""}
            size="small"
            fullWidth
            placeholder="Ingrese descripcion"
            onChange={handleInputChange}
            disabled={form.id_contacto > 0 ? false : true}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Correo eléctronico"
            variant="standard"
            name="email"
            id="outlined-size-small"
            value={form?.email || ""}
            size="small"
            fullWidth
            placeholder="Ingrese descripcion"
            onChange={handleInputChange}
            disabled={form.id_contacto > 0 ? false : true}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Fono"
            name="fono"
            variant="standard"
            id="outlined-size-small"
            value={form?.fono || ""}
            size="small"
            fullWidth
            placeholder="Ingrese fono"
            onChange={handleInputChange}
            disabled={form.id_contacto > 0 ? false : true}
          />
        </Grid>

        <Grid item xs={6}>
          <label>
            Ingreso esperado
            <NumberFormat
              className="text-end p-cantidades-item-new2"
              name="total"
              value={form?.total || 0}
              thousandSeparator={local_separacion_miles}
              decimalSeparator={local_separacion_decimales}
              prefix={`${local_simbolo} `}
              decimalScale={2}
              fixedDecimalScale={2}
              onValueChange={(values, sourceInfo) =>
                handleChangeNumber({ ...values, sourceInfo })
              }
              disabled={form.id_contacto > 0 ? false : true}
            />
          </label>
        </Grid>

        <Grid item xs={12} className="mt-4">
          <TextField
            fullWidth
            className="text-area-resize"
            id="outlined-multiline-static"
            name="nota"
            label="Nota"
            multiline
            rows={5}
            value={form.nota || ""}
            onChange={handleInputChange}
            disabled={form.id_contacto > 0 ? false : true}
          />
        </Grid>

        <Grid item xs={12} className="mt-2">
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">
              Tipo prospecto
            </InputLabel>
            <Select
              label="Tipo prospecto"
              variant="standard"
              id="id_tipo_prospecto"
              name="id_tipo_prospecto"
              value={form.id_tipo_prospecto || ""}
              onChange={handleInputChange}
              className="p-list-capitalize"
              disabled={form.id_contacto > 0 ? false : true}
            >
              <MenuItem value="" key="">
                Ninguno
              </MenuItem>
              {tiposProspectos.map((item) => (
                <MenuItem
                  value={item.id}
                  key={item.id}
                  className="p-list-capitalize"
                >
                  {item.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Ubicación"
            variant="standard"
            name="ubicacion"
            id="outlined-size-small"
            value={form?.ubicacion || ""}
            size="small"
            fullWidth
            placeholder="Ingrese ubicación"
            onChange={handleInputChange}
            disabled={form.id_contacto > 0 ? false : true}
          />
        </Grid>

        <Grid item xs={12} className="mt-2">
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">Origen</InputLabel>
            <Select
              label="Origen"
              variant="standard"
              id="id_origen"
              name="id_origen"
              value={form?.id_origen || ""}
              onChange={handleInputChange}
              className="p-list-capitalize"
              disabled={form.id_contacto > 0 ? false : true}
            >
              <MenuItem value="" key="">
                Ninguno
              </MenuItem>
              {listaOrigen?.map((item) => (
                <MenuItem
                  value={item.id}
                  key={item.id}
                  className="p-list-capitalize"
                >
                  {item.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {parseInt(form.id_origen) === 1 && (
          <Grid item xs={12}>
            <TextField
              label="Referido por"
              variant="standard"
              name="referido_por"
              id="outlined-size-small"
              value={form?.referido_por || ""}
              size="small"
              fullWidth
              placeholder="Ingrese nombre"
              onChange={handleInputChange}
              disabled={form.id_contacto > 0 ? false : true}
            />
          </Grid>
        )}

        <Grid item xs={12} className="text-end mt-5">
          {form.id_contacto > 0 && (
            <Button
              className="p-btn-primary"
              variant="contained"
              size="medium"
              type="button"
              onClick={handleSave}
            >
              Guardar
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
};
export default OportunidadesForm;
